export const BASE_API_URL = `${process.env.CARVANA_APP_TRADES_API}`;

export const getVersionBase = (version: number) => {
  if (version >= 1) {
    return `${process.env.CARVANA_APP_TRADES_API}/api/v${version}`;
  }
  return BASE_API_URL;
};
